import { isPlatformBrowser } from '@angular/common';
import { EventEmitterService } from '@core/services/event-emitter.service';
import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';
import { Router } from '@angular/router';
import { GameCategoryHttpService } from '@core/services/game-category-http.service';
import { map, tap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { JackpotService } from '@core/services/jackpot.service';
import { MatDialog } from '@angular/material/dialog';
import { GameListDataService } from '@core/services/games/gamelist-data.service';
import { environment } from '@env/environment';
import { GameLaunchWindowTargetService } from '@core/services/game-launch-target.service.ts';
import { CommonModule } from '@angular/common';
import { ClientOdometerComponent } from '@shared/odometer/client-odometer.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-jackpot-slider',
  imports: [CommonModule, CarouselModule, ClientOdometerComponent, TranslateModule],
  templateUrl: './jackpot-slider.component.html',
  styleUrls: ['./jackpot-slider.component.scss'],
})
export class JackpotSliderComponent implements OnInit, OnDestroy {

  private jackpotDataSubscription: Subscription;

  odometerConfig = {
    animation: 'slide',
    format: '(,ddd).dd',
    theme: 'default',
    auto: true,
  }

  availableProvider: any = null;
  SGisActive = false; 
  PTisActive = false;

  customOptionsJacpot: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    navSpeed: 1000,
    autoplaySpeed: 1000,
    autoplay: true,
    items: 1,
    nav: false,
    animateOut: 'animate__animated animate__slideOutDown',
  };

  gameCodeByJacpot: any = {
    MGC:  'S-LB01',
    FUFU: 'S-FO01',
    ADV:  'S-PO02',
    GJ:   'S-DG03',
    CJ:   'S-EG02',
  };

  gameCodeByJacpotPostion = [
    'MGC', // 1
    'FUFU', // 2
    'ADV', // 3
    'GJ', // 4
    'CJ' // 5
  ];

  gameCodeByJacpotPt: any = {
    // 'jpgt6-1':  'jpgt',
    // 'ashlcl-1': 'ashlcl',
    // 'ashbob-1':  'ashbob',
    'cnpr4':   'cnpr',
    // kfp:   'kfp',
    'dcjp-4': 'gpas_etpop_pop',
    'pisa': 'pisa',
    'bjp-4': 'gpas_bprog_pop'
  };

  gameCodeByJacpotPostionPt = [
    // 'jpgt6-1', // 1
    // 'ashlcl-1', // 2
    // 'ashbob-1', // 3
    'cnpr4', // 4
    // 'kfp' // 5
    'dcjp-4', // 6
    'pisa', // 7
    'bjp-4' // 8
  ];

  jackpot: any[] = [];
  gameList: any;
  gameListPt: any;
  ptgamelistcheck = false

  isBrowser: boolean;

  constructor(
    private eventEmitterService: EventEmitterService,
    private jackpotService: JackpotService,
    private router: Router,
    private gameCategoryHttpService: GameCategoryHttpService,
    public dialog: MatDialog,
    private gameListHttpService: GameListDataService,
    private gameLaunchWindowTargetService: GameLaunchWindowTargetService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    if (this.isBrowser) {
      this.availableProvider = JSON.parse(localStorage.getItem('available_providers'));
    }
  }

  ngOnInit() {
    if(this.availableProvider && this.availableProvider['SL'].find((x: any) => x.game_provider_code == 'SG')) this.SGisActive = true;
    if(this.availableProvider && this.availableProvider['SL'].find((x: any)  => x.game_provider_code == 'PTI') || !environment.production ) this.PTisActive = true;
    this.getGameList();
    this.getGameListPT();
    //for testing number update
    // var plus = 0;
    this.jackpotDataSubscription = this.eventEmitterService.jackpotDataEventEmitter.subscribe((data: any) => {
      data = this.formDataArray(data['jackpot']);
      if(!this.availableProvider && this.isBrowser) { // fetch one more time if initialize failed
        this.availableProvider = JSON.parse(localStorage.getItem('available_providers'));
        if(this.availableProvider && this.availableProvider['SL'].find((x: any)  => x.game_provider_code == 'SG')) this.SGisActive = true;
        if(this.availableProvider && this.availableProvider['SL'].find((x: any)  => x.game_provider_code == 'PTI') || !environment.production ) this.PTisActive = true;
      }
      
      if(this.jackpot.length == 0) {
        this.jackpot = data;
      }else{
        // update only amount, instead array due to the slider will re-render problem
        if(this.jackpot.length > 0 && data.length  > 0){
          let jackpotlist: any = this.jackpot;
          Object.keys(jackpotlist).forEach(function (key) {
            //for testing number update
            // plus = plus + 5;
            // data[key]['amount']['MYR'] = data[key]['amount']['MYR'] + plus;  

            // only amount different only will update
            if( JSON.stringify(data[key]['amount']) !== JSON.stringify(jackpotlist[key]['amount']) ){
              jackpotlist[key]['amount'] = data[key]['amount'];
            }
          });
          this.jackpot = jackpotlist;
        }
      }
    });

    this.jackpotService.jackpotWebsocket();
  }

  ngOnDestroy() {
    this.jackpotService.disconnectSocket();
    if (this.jackpotDataSubscription) {
      this.jackpotDataSubscription.unsubscribe();
    }
  }

  getOffset(el: any) {
    el = el.getBoundingClientRect();
    return {
      left: el.left + (this.isBrowser ? window.scrollX : 0),
      top: el.top + (this.isBrowser ? window.scrollY : 0),
      bottom: el.top + (this.isBrowser ? window.scrollY : 0)
    };
  }

  scroll() {
    if (!this.isBrowser) return;
    const scrollTo = document.getElementById('content');
    const topHight = this.getOffset(scrollTo).top;
    window.scrollTo(0, topHight);
  }


  onLaunchGame(data: string, gameProvider: any) {

    if(gameProvider == 'SG'){
      var gameCode = this.gameList[this.gameCodeByJacpot[data]]['code'];
      data = 'Launch|SG||'+gameCode;
    }else{
      var gameCode = this.gameListPt[this.removeFormat(this.gameCodeByJacpotPt[data])]['code'];
      data = 'Launch|PTI||'+gameCode;
    }

    // E.g data : Launch|game_provider_code|subCategoryCode|game_code, Launch|EZ|roulette|481000
    let datas = data.split('|');
    this.gameCategoryHttpService.getGames('SL').pipe(
      map(res => res.find(x => x.game_provider_code === datas[1]))
    ).subscribe((gameProvider: any) => {
      // To update the params on the URL
      const dateEnd = Date.parse(gameProvider.maintain_end);
      const dateNow = new Date().getTime();

      if (!this.isBrowser || localStorage.getItem('user_data') === null) {
        // TODO
        // this.dialog.open(LoginModalComponent, { width: 'auto' });
      }
      else if (gameProvider.maintenance === 1 && dateEnd > dateNow) {
        // TODO
        // this.dialog.open(CountDownDetailsComponent, {
        //   width: 'auto',
        //   data: {
        //     dateEnd: gameProvider.maintain_end,
        //     name: gameProvider.game_provider_name,
        //     time: gameProvider.maintain_time_left,
        //   }
        // });
      }
      //maintenance with no end date
      else if (gameProvider.maintenance === 1 && gameProvider.maintain_end === '') {
        // TODO
        // this.dialog.open(CountDownDetailsComponent, {
        //   width: 'auto',
        //   data: {
        //     name: gameProvider.game_provider_name,
        //     time: gameProvider.maintain_time_left,
        //   }
        // });
      } else {
        localStorage.setItem('gameProviderCode', gameProvider.game_provider_code);
        localStorage.setItem('gameCategory', 'SL');
        localStorage.setItem('gameProviderId', gameProvider.game_provider_id);
        datas[2] !== undefined ? localStorage.setItem('subCategoryCode', datas[2]) : localStorage.removeItem('subCategoryCode');
        datas[3] !== undefined ? localStorage.setItem('gameCode', datas[3]) : localStorage.removeItem('gameCode');

        // localStorage.setItem('isPlayTechClicked', (gameProvider.game_provider_code === "PT").toString());
        localStorage.setItem('gameMode', 'real');
        localStorage.setItem('lobbyUrl', location.href);

        if (this.isBrowser) {
          this.router.navigate([]).then(() => { window.open('/gamelaunch', this.gameLaunchWindowTargetService.getTarget(gameProvider.game_provider_code)); });
        }
      }
    })

  }

  onGetCurrencyCode() {
    let currency_code = 'MYR'; //default MYR
    if (this.isBrowser) {
      if (localStorage.getItem('country_code')?.toUpperCase() == 'SG') {
        currency_code = 'SGD';
      } else if (localStorage.getItem('country_code')?.toUpperCase() == 'ID') {
        currency_code = 'IDR';
      }
    }
    return currency_code;
  }

  transferAmount(data: any){
    let amount = +parseFloat(data).toFixed(2);

    //Workaround to deal with floating point arithmetic issue
    if (Math.round(amount * 100) % 10 == 0) {
      amount = amount + 0.01
    }

    return amount;
  }

  getGameList() {
      var games: any = {};
      // hard code to get Spade game,slot gamelist
      this.gameListHttpService.getALLGamesBy('SG', 'SL').pipe(
        tap((res: any) => {
          Object.keys(res).forEach(function (key) {
            if(res[key]['status'] == "ACTIVE") games[res[key]['code']]  = res[key];
          });
          this.gameList = games;
        })
      ).subscribe();
  }

  getGameListPT() {
    var games: any = {};
    // hard code to get Playtech game , for qa testing
    if (!environment.production) {
      games['jpgt'] = {
          "code":  "jpgt",
          "GameProviderCode" : "PTI"
      };
      games['ashlcl'] = {
        "code":  "ashlcl",
        "GameProviderCode" : "PTI"
      };
      games['cnpr'] = {
          "code":  "cnpr",
          "GameProviderCode" : "PTI"
      };
      games['kfp'] = {
        "code":  "kfp",
        "GameProviderCode" : "PTI"
      };
      games['ashbob'] = {
        "code":  "ashbob",
        "GameProviderCode" : "PTI"
      };
      games['gpas_etpop_pop'] = {
        "code":  "gpas_etpop_pop",
        "GameProviderCode" : "PTI"
      };
      games['pisa'] = {
        "code":  "pisa",
        "GameProviderCode" : "PTI"
      };
      games['gpas_bprog_pop'] = {
        "code":  "gpas_bprog_pop",
        "GameProviderCode" : "PTI"
      };

      this.gameListPt = games;

    }else{
      this.gameListHttpService.getALLGamesBy('PTI', 'SL').pipe(
      tap((res: any) => {
        Object.keys(res).forEach(function (key) {
          if(res[key]['status'] == "ACTIVE") games[res[key]['code']]  = res[key];
        });
        this.gameListPt = games;
      })
    ).subscribe();
    }

  }

  formDataArray(data: any) {
    var games: any = [];
    Object.keys(data).forEach(element => {
      Object.keys(data[element]['data']).forEach(element2 => {
        data[element]['data'][element2]['GameProviderCode'] = element;
        games.push(data[element]['data'][element2]);
      }); 
    });
    return games;
  }

  removeFormat(data: any){
    return data.replace('-1', '') as string;
  }

  checkPTgame(){

    if(this.ptgamelistcheck){
      return true;
    }

    if( this.jackpot && this.jackpot.length > 0 ){
      var jackpotlist = this.jackpot;
      var gameCodeByJacpotPostionPt: any  = this.gameCodeByJacpotPostionPt;
      Object.keys(gameCodeByJacpotPostionPt).forEach((key) => {
        // console.log(gameCodeByJacpotPostionPt[key]);
        if( jackpotlist.find(x => x.code == gameCodeByJacpotPostionPt[key])) {
          this.ptgamelistcheck = true;
          return true;
        }
        return false;
      });
    }
    return false;
  }
}
